/* eslint-disable max-len */
import React, {FC} from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import BaseSvgIcon from "../Base"

interface Props extends WithDefaultTheme {}

const CircleAlertFill: FC<Props> = ({theme, ...props}) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <g fill="none">
        <path
          fill="#EA4747"
          d="M8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8 C15.9948137,3.58387202 12.416128,0.00518629776 8,0 Z"
        />
        <path
          fill={theme.colors.utility.white}
          d="M8 8.5C7.72385763 8.5 7.5 8.31345198 7.5 8.08333333L7.5 3.91666667C7.5 3.68654802 7.72385763 3.5 8 3.5 8.27614237 3.5 8.5 3.68654802 8.5 3.91666667L8.5 8.08333333C8.5 8.31345198 8.27614237 8.5 8 8.5zM8 12.5C7.72385763 12.5 7.5 12.2761424 7.5 12L7.5 11C7.5 10.7238576 7.72385763 10.5 8 10.5 8.27614237 10.5 8.5 10.7238576 8.5 11L8.5 12C8.5 12.2761424 8.27614237 12.5 8 12.5z"
        />
      </g>
    </BaseSvgIcon>
  )
}

export default withTheme(CircleAlertFill)
